var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ranking-popup", attrs: { role: "list" } },
    _vm._l(_vm.entries, function (e) {
      return _c(
        "div",
        {
          key: e.name,
          staticClass: "ranking-entry",
          attrs: { role: "listitem" },
        },
        [
          _c("a", { attrs: { target: "_blank", href: e.href } }, [
            _vm._v(_vm._s(e.name)),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }